var render = function render(_c,_vm){return _vm._m(0)
}
var staticRenderFns = [function (_c,_vm){return _c('div',{staticClass:"S-loader"},[_c('div',{staticClass:"S-loader__bouncer"}),_vm._v(" "),_c('div',{staticClass:"S-loader__bouncer"}),_vm._v(" "),_c('div',{staticClass:"S-loader__bouncer"})])
}]

export { render, staticRenderFns }